import { fetchJSON as fetchAPI } from './client';

export type SprintDashboard = {
  sprint_id: string; objectives: number; intelligence_modules: number;
  provider_interfaces: number; background_jobs: number; quality_gates: number;
  backend_apis: number; database_tables: number; generated_at: string;
};

export type SprintValidation = {
  valid: boolean; true_profit_operational: boolean; leakage_detection_operational: boolean;
  settlement_reconciliation_operational: boolean; recovery_workflows_operational: boolean;
  recommendations_from_dna: boolean; experiments_auto_created: boolean;
  marketplace_dna_updated: boolean; financial_forecasts_measurable: boolean; gaps?: string[];
};

export type Dev109Status = {
  sprint_id: string; objectives: number; intelligence_modules: number;
  profit_intelligence_platform: boolean; production_ready: boolean; dna_integrated: boolean;
  financial_forecasts_measurable: boolean; status: string;
};

const GOVERNANCE_BASE = import.meta.env.VITE_GOVERNANCE_API ?? '/api/v1/governance';
const fetchG = <T,>(path: string, init?: RequestInit) => fetchAPI<T>(`${GOVERNANCE_BASE}${path}`, init);

export const profitIntelligenceDev109Api = {
  dashboard: () => fetchG<SprintDashboard>('/dev109/dashboard'),
  objectives: () => fetchG<{ objectives: { key: string; name: string; category: string }[] }>('/dev109/objectives').then((r) => r.objectives),
  intelligenceModules: () => fetchG<{ modules: { key: string; name: string; category: string }[] }>('/dev109/intelligence-modules').then((r) => r.modules),
  providers: () => fetchG<{ providers: { key: string; name: string; interface: string }[] }>('/dev109/service-architecture').then((r) => r.providers),
  backgroundJobs: () => fetchG<{ jobs: { key: string; name: string; schedule?: string }[] }>('/dev109/background-jobs').then((r) => r.jobs),
  qualityGates: () => fetchG<{ gates: { key: string; name: string; blocking: boolean }[] }>('/dev109/quality-gates').then((r) => r.gates),
  validate: (attrs: Record<string, boolean>) =>
    fetchG<SprintValidation>('/dev109/validate', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attrs }) }),
  status: () => fetchG<Dev109Status>('/dev109/status'),
};
